/*
 * @Author: LiuChuanQi
 * @Date: 2022-11-30 14:24:48
 * @LastEditTime: 2022-12-14 17:12:41
 * @LastEditors: LiuChuanQi
 * @Description: 账号登录校验方法
 * @FilePath: \speedtest-bigdata-v2\src\utils\hooks\checkInfor.js
 * 
 */
/**
 * 手机号码
 * @param val 字符串
 * @returns true: 手机号码正确
 */
export function verifyPhone (val) {
	if (!/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/.test(val)) return false
	else return true
}

/**
 * 登录账号 (字母开头，允许5-16字节，允许字母数字下划线)
 * @param val 字符串
 * @returns true: 登录账号正确 false :登录账号错误
 */
export function verifyAccount (val) {
	if (!/^[a-zA-Z][a-zA-Z0-9_]{4,15}$/.test(val)) return false
	else return true
}

/**
 * 密码 (以字母开头，长度在6~16之间，只能包含字母、数字和下划线)
 * @param val 字符串
 * @returns  true: 密码正确， false :密码错误
 */
export function verifyPassword2 (val) {
	if (!/^[a-zA-Z]\w{5,15}$/.test(val)) return false
	else return true
}

/**
 * 
 * @param {*} val 
 */
export function verifyPassword (val) {
	var pwdCount = 0//统计密码包含了几种字符
	var pwdRegex1 = new RegExp('(?=.*[0-9]).{8,30}')//纯数字
	var pwdRegex2 = new RegExp('(?=.*[a-z]).{8,30}')//小写字母
	var pwdRegex3 = new RegExp('(?=.*[A-Z]).{8,30}')//大写字母
	var pwdRegex4 = new RegExp('((?=[\x21-\x7e]+)[^A-Za-z0-9])')//特殊字符 这个匹配所有键盘上可见的非字母和数字的符号


	if (pwdRegex1.test(newPassword)) {
		pwdCount = pwdCount + 1
	}

	if (pwdRegex2.test(newPassword)) {
		pwdCount = pwdCount + 1
	}

	if (pwdRegex3.test(newPassword)) {
		pwdCount = pwdCount + 1
	}

	if (pwdRegex4.test(newPassword)) {
		pwdCount = pwdCount + 1
	}
}

// 校验邮箱
export const verifyMailbox = function (val) {
	let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
	if (regEmail.test(val)) return true
	return false
}


// 节流函数
export const throttle = function (fn, interval) {
	var _self = fn, // 保存需要被延迟执行的函数引用
		timer, // 定时器
		firstTime = true // 是否是第一次调用
	return function () {
		var args = arguments
		_me = this
		if (firstTime) { // 如果是第一次调用不需要延迟
			_self.apply(_me, args) // 执行fn函数并且修正此函数中this所运行的上下文指向
			return firstTime = false
		}
		if (timer) { // 如果定时器还在，说明前一次延迟执行还没有完成
			return false
		}
		timer = setTimeout(function () { // 延迟一段时间执行
			clearTimeout(timer)
			timer = null
			_self.apply(_me, args) // 执行fn函数并且修正此函数中this所运行的上下文指向
		}, interval || 500)
	}
}


